import React, {ChangeEvent, useEffect, useState} from 'react';
import {Box, TextField, Button, Paper, Typography} from '@mui/material';
import { useAppDispatch } from '../../../app/hooks';
import {closeButton, closeButtonInner, form, formInner, overlay} from "../../Players/components/playerFormStyles";
import CloseIcon from "@mui/icons-material/Close";
import {Controller, useForm} from "react-hook-form";
import {IUpdateUserPayload, IUser, updateUser} from "../usersSlice";
import {isValidData} from "../../../helpers/isValidData";
import {toast} from "react-toastify";



interface IUserFormProps {
    editingUser: IUser | null,
    onCloseForm: () => void
}

export enum userFormFields {
    FACEBOOK = "facebook",
    LINKEDIN = "linkedIn",
    COMMENTS = "comments",
    HOME_TOWN = "hometown",
    COUNTRY = "country",
    TELEPHONE = "telephone",
    EMAIL = "email",
    WEBSITE = "webSite",
}

interface IUserFormData {
    facebook: string,
    linkedIn: string,
    comments: string
    hometown: string,
    country: string,
    telephone: string,
    email: string,
    webSite: string
}


const UserForm: React.FC<IUserFormProps> = ({editingUser, onCloseForm}) => {
    const [formData, setFormData] = useState<IUserFormData>({
        facebook: "",
        linkedIn: "",
        comments: "",
        hometown: "",
        country: "",
        telephone: "",
        email: "",
        webSite: ""
    });
    const {handleSubmit, control, reset} = useForm<IUserFormData>();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (editingUser) {
            const userFormData = {
                facebook: editingUser.socialMedia ? editingUser.socialMedia.facebook : "",
                linkedIn: editingUser.socialMedia ? editingUser.socialMedia.linkedIn : "",
                comments: editingUser.socialMedia ? editingUser.socialMedia.comments : "",
                hometown: editingUser.contact ? editingUser.contact.hometown : "",
                country: editingUser.contact ? editingUser.contact.country : "",
                telephone: editingUser.contact ? editingUser.contact.telephon : "",
                email: editingUser.contact ? editingUser.contact.email : "",
                webSite: editingUser.contact ? editingUser.contact.webSite : "",
            }
            setFormData(userFormData);
            reset(userFormData);
        }

    }, [editingUser])


    const handleChange = (field: keyof IUserFormData, e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({...formData, [field]: e.target.value});
    };


    const onSubmit = () => {
        if (!isValidData(formData)){
            toast.warning("SDC: Fill the form")
            return;
        }
        if (!editingUser) {
            return
        }

        const reqBody: IUpdateUserPayload = {
            payload: {
                id: editingUser.id,
                socialMedia: {
                    facebook: formData.facebook,
                    linkedIn: formData.linkedIn,
                    comments: formData.comments
                },
                contact: {
                    hometown: formData.hometown,
                    country: formData.country,
                    telephon: formData.telephone,
                    email: formData.email,
                    webSite: formData.webSite
                }
            },
            closeForm: onCloseForm
        }

        dispatch(updateUser(reqBody));
    };

    return (
        <Box sx={overlay}>
            <Box>
                <Paper sx={formInner}>
                    <Box sx={closeButtonInner}>
                        <Button
                            sx={closeButton}
                            onClick={onCloseForm}
                        >
                            <CloseIcon sx={{width: 20}}/>
                        </Button>
                    </Box>
                    <Typography variant="h5" align="center">
                        Edit User
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Box sx={form}>
                            <Controller
                                control={control}
                                name={userFormFields.FACEBOOK}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Facebook"
                                        value={formData.facebook}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.FACEBOOK, e)
                                        }}
                                        error={Boolean(errors.facebook)}
                                        helperText={
                                            errors.facebook && errors.facebook.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.facebook && errors.facebook.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.facebook && errors.facebook.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.LINKEDIN}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="LinkedIn"
                                        value={formData.linkedIn}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.LINKEDIN, e)
                                        }}
                                        error={Boolean(errors.linkedIn)}
                                        helperText={
                                            errors.linkedIn && errors.linkedIn.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.linkedIn && errors.linkedIn.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.linkedIn && errors.linkedIn.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.COMMENTS}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Comments"
                                        value={formData.comments}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.COMMENTS, e)
                                        }}
                                        error={Boolean(errors.comments)}
                                        helperText={
                                            errors.comments && errors.comments.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.comments && errors.comments.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.comments && errors.comments.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.COUNTRY}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Country"
                                        value={formData.country}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.COUNTRY, e)
                                        }}
                                        error={Boolean(errors.country)}
                                        helperText={
                                            errors.country && errors.country.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.country && errors.country.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.country && errors.country.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.HOME_TOWN}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Home town"
                                        value={formData.hometown}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.HOME_TOWN, e)
                                        }}
                                        error={Boolean(errors.hometown)}
                                        helperText={
                                            errors.hometown && errors.hometown.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.hometown && errors.hometown.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.hometown && errors.hometown.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.TELEPHONE}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Telephone"
                                        value={formData.telephone}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.TELEPHONE, e)
                                        }}
                                        error={Boolean(errors.telephone)}
                                        helperText={
                                            errors.telephone && errors.telephone.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.telephone && errors.telephone.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.telephone && errors.telephone.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.WEBSITE}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Website"
                                        value={formData.webSite}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.WEBSITE, e)
                                        }}
                                        error={Boolean(errors.webSite)}
                                        helperText={
                                            errors.webSite && errors.webSite.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.webSite && errors.webSite.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.webSite && errors.webSite.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name={userFormFields.EMAIL}
                                rules={{
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        label="Email"
                                        value={formData.email}
                                        onChange={(e) => {
                                            onChange(e)
                                            handleChange(userFormFields.EMAIL, e)
                                        }}
                                        error={Boolean(errors.email)}
                                        helperText={
                                            errors.email && errors.email.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.email && errors.email.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.email && errors.email.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Button variant="contained" type="submit">
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default UserForm;
